import { Component } from "../components/index"
import { qsa, qs, bounds } from "../utils/index"
import { gsap } from "../libraries/gsap/index"
import { formatMoney } from "../utils/index"
import { buildCart } from "../utils/Shopify"

export default class Cart extends Component {
  constructor(obj) {
    super(obj)

    this.trigger = qs("#mini-cart-trigger", this.el)
    this.backdrop = qs(".mini-cart-global-backdrop", this.el)
    this.cart = qs(".mini-cart", this.el)
    this.closeCart = qs("#mini-cart-close", this.el)

    this.cartActive = false

    this.loadingBg = qs(".loading-bg", this.el)

    this.addToCart = qsa("form[action='/cart/add']")

    buildCart()
  }

  on() {
    this.trigger.addEventListener("click", this.toggleCart)
    this.backdrop.addEventListener("click", this.toggleCart)
    this.closeCart.addEventListener("click", this.toggleCart)

    this.addToCart.forEach(form => {
      form.addEventListener("submit", e => this.onSubmit(e, form))
    })
  }

  off() {
    this.trigger.removeEventListener("click", this.toggleCart)
    this.backdrop.removeEventListener("click", this.toggleCart)
    this.closeCart.removeEventListener("click", this.toggleCart)

    // investigation on going
    // this.addToCart.forEach(form => {
    //   form.removeEventListener("submit", e => this.onSubmit(e, form))
    // })
  }

  onSubmit = async (e, form) => {
    e.preventDefault()

    this.loadingBg.classList.add("loading-bg_active")

    const formData = new FormData(form)
    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    })

    if (response.ok) {
      // console.log(response)

      buildCart()

      this.loadingBg.classList.remove("loading-bg_active")
    } else {
      console.error("add to cart failed")

      this.loadingBg.classList.remove("loading-bg_active")
    }
  }

  toggleCart = () => {
    this.cartActive = !this.cartActive

    this.backdrop.classList.toggle("mini-cart-global-backdrop_active")
    this.cart.classList.toggle("mini-cart_active")

    if (this.cartActive) {
      const header = qs(".mini-cart-header", this.el)
      const items = qsa(".mini-cart-item", this.el)
      const bottom = qs(".mini-cart-bottom", this.el)

      gsap.from(header, {
        opacity: 0,
        duration: 1.2,
      })
      gsap.from(bottom, {
        opacity: 0,
        duration: 1.2,
      })
      gsap.from(items, {
        stagger: 0.05,
        opacity: 0,
        y: 30,
        duration: 1.2,
      })
      // show cart
    } else {
      // hide cart
    }
  }
}
